import { Nullable, OneOrMore } from '@internal-libraries/kheops-ui-lib'
import { RoomType } from '../Types/RoomType'
import { RoomDto } from '../Types/RoomDto'
import { RoomApiAdapter } from '../Adapters/RoomApiAdapter'

export default class ClvrRoom {
    public id: Nullable<number> = null
    public roomOperationId: Nullable<number> = null
    public name = ''
    public alias = ''
    public stats = false
    public dh = false
    public checklistMan = false
    public color: Nullable<string> = null
    public active: Nullable<boolean> = null
    public code: Nullable<string> = null
    public checklistDefaultId: Nullable<number> = null
    public checklistDefaultHas: Nullable<string> = null
    public opConditionalAccess: Nullable<string> = null

    public constructor(data: RoomType) {
        Object.assign(this, data)
    }

    public toDto(): RoomDto {
        return {
            id: this.id,
            bloc_id: this.roomOperationId,
            nom: this.name,
            alias: this.alias,
            stats: this.stats,
            dh: this.dh,
            cheklist_man: this.checklistMan,
            color: this.color,
            actif: this.active,
            code: this.code,
            checklist_default_id: this.checklistDefaultId,
            checklist_default_has: this.checklistDefaultHas,
            op_conditional_access: this.opConditionalAccess,
        }
    }

    public static convertDtoToRoomList(refRooms: OneOrMore<RoomDto>): ClvrRoom[] {
        return Array.isArray(refRooms)
            ? refRooms.map(new RoomApiAdapter().createClass)
            : [new RoomApiAdapter().createClass(refRooms)]
    }
}
